import { forwardRef, type HTMLAttributes } from 'react';
import { cx } from './cx';

export type CardProps = HTMLAttributes<HTMLDivElement>;

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { className, ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      className={cx(
        'rounded-bubble border border-white/10 bg-hc-card p-5 shadow-card',
        className
      )}
      {...rest}
    />
  );
});
